import TrainingView from '../TrainingView.vue'

export const trainingRoute = [
  {
    path: '/trainings',
    name: 'training',
    component: TrainingView
  }
]
